// Frontend fallback / catalog. Backend `/api/subjects` and `/api/tags` are source of truth.
// These constants are used as initial render fallback and for shape stability.

export const SUBJECTS = [
  { value: "hrvatski-jezik", label: "Hrvatski jezik" },
  { value: "matematika", label: "Matematika" },
  { value: "priroda-i-drustvo", label: "Priroda i društvo" },
  { value: "priroda", label: "Priroda" },
  { value: "biologija", label: "Biologija" },
  { value: "kemija", label: "Kemija" },
  { value: "fizika", label: "Fizika" },
  { value: "geografija", label: "Geografija" },
  { value: "povijest", label: "Povijest" },
  { value: "tehnicka-kultura", label: "Tehnička kultura" },
  { value: "vjeronauk", label: "Vjeronauk" },
  { value: "engleski-jezik", label: "Engleski jezik" },
  { value: "informatika", label: "Informatika" },
  { value: "tjelesna-i-zdravstvena-kultura", label: "Tjelesna i zdravstvena kultura" },
  { value: "likovna-kultura", label: "Likovna kultura" },
  { value: "glazbena-kultura", label: "Glazbena kultura" },
  { value: "njemacki-jezik", label: "Njemački jezik" },
  { value: "talijanski-jezik", label: "Talijanski jezik" },
  { value: "latinski-jezik", label: "Latinski jezik" },
  { value: "likovna-umjetnost", label: "Likovna umjetnost" },
  { value: "glazbena-umjetnost", label: "Glazbena umjetnost" },
  { value: "etika", label: "Etika" },
  { value: "psihologija", label: "Psihologija" },
  { value: "logika", label: "Logika" },
  { value: "filozofija", label: "Filozofija" },
  { value: "sociologija", label: "Sociologija" },
  { value: "politika-i-gospodarstvo", label: "Politika i gospodarstvo" },
];

export const GRADE_LEVELS = [
  { value: "1", label: "1. razred OŠ" },
  { value: "2", label: "2. razred OŠ" },
  { value: "3", label: "3. razred OŠ" },
  { value: "4", label: "4. razred OŠ" },
  { value: "5", label: "5. razred OŠ" },
  { value: "6", label: "6. razred OŠ" },
  { value: "7", label: "7. razred OŠ" },
  { value: "8", label: "8. razred OŠ" },
  { value: "g1", label: "1. razred gimnazije" },
  { value: "g2", label: "2. razred gimnazije" },
  { value: "g3", label: "3. razred gimnazije" },
  { value: "g4", label: "4. razred gimnazije" },
];

export const GRADE_GROUPS = [
  { label: "Osnovna škola", grades: GRADE_LEVELS.filter((g) => !g.value.startsWith("g")) },
  { label: "Gimnazija", grades: GRADE_LEVELS.filter((g) => g.value.startsWith("g")) },
];

// Universal across all subjects/grades — matches GENERAL_TAGS in backend
export const GENERAL_TAGS = [
  "Aktivno sudjeluje na satu",
  "Redovito se javlja za riječ",
  "Pažljivo prati nastavu",
  "Postavlja relevantna pitanja",
  "Povremeno gubi koncentraciju",
  "Redovito piše domaće zadaće",
  "Donosi potreban pribor",
  "Izvršava zadatke na vrijeme",
  "Često zaboravlja pisati zadaće",
  "Uredno vodi bilježnicu",
  "Pokazuje vidljiv napredak",
  "Brzo usvaja novo gradivo",
  "Treba više vježbe i ponavljanja",
  "Pokazuje izraženu motivaciju za učenje",
  "Pokazuje kreativnost u radu",
  "Dobro surađuje u skupini",
  "Pomaže drugim učenicima",
  "Samostalno rješava zadatke",
  "Pruža podršku slabijim učenicima",
  "Često se oslanja na pomoć drugih",
];

// Initial fallback for subject-specific tags (Matematika, 4. razred OŠ).
// Real tags come from backend `/api/tags?subject=...&grade=...`
export const SUBJECT_TAGS = [
  "Sigurno računa s brojevima do milijun",
  "Sigurno množi i dijeli višeznamenkastim brojem",
  "Razumije razlomke i decimalne brojeve",
  "Sigurno pretvara mjerne jedinice",
  "Računa opseg i površinu kvadrata i pravokutnika",
  "Točno rješava složenije zadatke riječima",
  "Sigurno koristi geometrijski pribor",
  "Logički povezuje matematičke sadržaje",
  "Treba dodatne vježbe pri pretvaranju mjernih jedinica",
  "Sporiji u radu s razlomcima",
  "Vidljiv napredak u rješavanju problemskih zadataka",
  "Pažljivo provjerava rezultate",
  "Pokazuje interes za izazovne zadatke",
  "Brzo i točno računa napamet",
  "Kreativno pristupa rješavanju problema",
];
